<template>
  <div class="form-News-card">
    <div class="form-box">
      <el-select v-model="searchType" @change="searchValue = ''" placeholder="请选择">
        <el-option label="公告名称" value="newsTitle"></el-option>
        <el-option label="公告时间" value="newsCreateTime"></el-option>
        <el-option label="公告内容" value="newsContent"></el-option>
      </el-select>
      <template>
        <el-input
          v-if="searchType !== 'newsCreateTime'"
          v-model="searchValue"
          placeholder="请输入内容"
          clearable
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-date-picker
          v-else
          v-model="searchValue"
          type="date"
          placeholder="选择日期"
          clearable
        ></el-date-picker>
      </template>
      <el-button type="primary" @click="handleSearch">查找</el-button>
    </div>
    <el-table :data="list" style="width: 100%">
      <el-table-column header-align="center" prop="newsTitle" :label="columnLabel">
        <template slot-scope="scope">
          <div class="ellipsis-news-title" @click="handleClick(scope.row)">{{ scope.row.newsTitle }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="newsCreateTime" label="发布时间" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row.newsCreateTime.substring(0, 10) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { parseTime } from '@/utils/ruoyi'
import { getMenuById } from '@/config/menus'

export default {
  name: 'FormNewsCard',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchType: 'newsTitle',
      searchValue: '',
      menuId: "",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        this.menuId = v.params?.menuId || v.query?.linkMenuId || sessionStorage.getItem("asideActiveId")|| ""
      },
    },
  },
  computed: {
    columnLabel() {
      return getMenuById(this.menuId)?.name || '招标公告'
    }
  },
  methods: {
    handleSearch() {
      if (this.searchType === 'newsCreateTime') {
        this.searchValue = this.searchValue ? parseTime(this.searchValue, "{y}-{m}-{d}") : ''
      }
      this.$emit('search', {
        [this.searchType]: this.searchValue,
      })
      this.searchValue = ''
    },
    handleClick(row) {
      this.$router.push({
        path: `/index/info/${row.id}`,
        query: {
          linkMenuId: row?.newsMenuId || ""
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.form-News-card ::v-deep {
  .form-box {
    margin-bottom: 18px;
    display: flex;
    gap: 10px;
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-table__header-wrapper {
    > table > thead th {
      background: #76add8;
      color: #ffffff;
      font-size: 16px;
      padding: 8px 0;
      font-weight: normal;
    }
  }
  .el-table__body-wrapper {
    > table > tbody tr td {
      padding: 0;
      .cell{
        padding: 0;
        color: #555555;
        font-size: 16px;
      }
    }
  }
  .ellipsis-news-title {
    cursor: pointer;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 50px;
    padding-left: 20px;
    background: url("../assets/images/js.png") 4px center no-repeat;
    &:hover {
      color: #fdc202;
    }
  }
}

</style>